<script setup>
import { validationCheck, regex } from '@utils'

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRouter } from 'vue-router'
const router = useRouter()

import Main from './Main.vue'
import BusinessProfileAddress from '../settings/BusinessProfileAddress.vue'
import ButtonBack from './ButtonBack.vue'
import ButtonSubmit from './ButtonSubmit.vue'
import { onMounted } from 'vue'

const saveGeneralSettings = async () => {
    // validation
    // manually sync this validation with settings/BusinessProfile.vue
    let { errors } = validationCheck([
        {
            condition: !$settings.business.email,
            message: 'Email is required',
        },
        {
            condition: $settings.business.email && !regex.email.test($settings.business.email),
            message: 'Invalid email format',
        },
        {
            condition: $settings.business.phone && !regex.phone.test($settings.business.phone),
            message: 'Invalid phone number format',
        },
    ])
    if (errors) return

    await $settings.saveSettings('business', $settings.business)
    // Toast.success('Updated business profile')

    router.push({ name: 'dashboard' })
}

onMounted(() => {
    // $settings.fetchSettings()
})
</script>

<template>
    <Main title="Set Your Contact Information" :progress="100">
        <BusinessProfileAddress />


        <template #footer>
            <ButtonBack text="Prev" @click="router.push({ name: 'onboarding.business.info' })" />
            <ButtonSubmit @click="saveGeneralSettings()" />
        </template>
    </Main>
</template>